import React from "react"
import { IconButton } from "@mui/material"
import VisibilityIcon from "@mui/icons-material/Visibility"
import { EmployeeProgressRow } from "../interfaces"
import { DownloadIcon } from "../../../icons"
import { Input } from "@fullscreendigital/carrefour-dex-fe"

export const toUiRows = (list: any[]): any[] =>
  list.map((r: any) => {
    const st = r.employeeStatusList?.[0]
    return {
      id: r.id,
      employeeId: r.employeeId,
      afgCardId: r.afgCardId,
      firstName: r.firstName,
      lastName: r.lastName,
      locationCode: r.locationCode,
      locationName: r.locationName,
      locationType: r.locationType,
      userId: r.userId,
      userName: r.userName,
      status: r.status,
      totalEligibleAmount: st?.eligibleSpendRequestedMonth ?? 0,
      cashbackAmount: st?.cashbackAmountRequestedMonth ?? 0,
      year: st?.year,
      month: st?.month,
    }
  })

export const toTableRowItems = (uiRows: any[]) =>
  uiRows.map((r: any) => ({
    ...r,
    totalEligibleAmountLabel: `${Number(r.totalEligibleAmount ?? 0).toFixed(2)} RON`,
    cashbackAmountLabel: `${Number(r.cashbackAmount ?? 0).toFixed(2)} RON`,
  }))

export const columns = ({ onDetails }: {
  onDetails: (row: EmployeeProgressRow) => void
}) => [
  { title: "ID angajat", field: "employeeId", align: "left", type: "string", disableSorting: true, width: "120px" },
  { title: "AFG card", field: "afgCardId", align: "left", type: "string", disableSorting: true, width: "160px" },
  { title: "Prenume", field: "firstName", align: "left", type: "string", disableSorting: true, width: "140px" },
  { title: "Nume", field: "lastName", align: "left", type: "string", disableSorting: true, width: "160px" },
  { title: "Cod locație", field: "locationCode", align: "left", type: "string", disableSorting: true, width: "140px" },
  { title: "Locație", field: "locationName", align: "left", type: "string", disableSorting: true, width: "180px" },
  { title: "Tip locație", field: "locationType", align: "left", type: "string", disableSorting: true, width: "110px" },
  { title: "User ID", field: "userId", align: "left", type: "string", disableSorting: true, width: "110px" },
  { title: "Username", field: "userName", align: "left", type: "string", disableSorting: true, width: "160px" },
  { title: "Status", field: "status", align: "left", type: "string", disableSorting: true, width: "120px" },
  { title: "Eligibil", field: "totalEligibleAmountLabel", align: "right", type: "string", disableSorting: true, width: "130px" },
  { title: "Cashback", field: "cashbackAmountLabel", align: "right", type: "string", disableSorting: true, width: "130px" },
  {
    title: "",
    field: "actions",
    align: "center",
    type: "string",
    width: "80px",
    render: (row: EmployeeProgressRow) => (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <IconButton size="small" onClick={() => onDetails(row)} aria-label="Detalii">
          <VisibilityIcon fontSize="small" />
        </IconButton>
      </div>
    ),
  },
]

export const toolbarActions = ({ onRefresh, isLoading, handleExport, isExporting, canExport }) => {
  const actions: any[] = [
    {
      label: isLoading ? "Se încarcă..." : "Refresh",
      onClick: onRefresh,
      disabled: isLoading
    },
    {
      label: isExporting ? 'Export in curs...' : 'Export',
      icon: <DownloadIcon />,
      onClick: handleExport,
      disabled: !canExport
    }
  ]

  return actions
}

export const drawerFilters = () => [
  {
    name: 'employee.employeeId',
    value: '',
    filter: <Input variant="outlined" label="ID angajat" type="text" />,
    type: 'text',
    label: 'ID angajat'
  },
  {
    name: 'employee.afgCardId',
    value: '',
    filter: <Input variant="outlined" label="AFG card" type="text" />,
    type: 'text',
    label: 'AFG card'
  },
  {
    name: 'employee.firstName',
    value: '',
    filter: <Input variant="outlined" label="Prenume" type="text" />,
    type: 'text',
    label: 'Prenume'
  },
  {
    name: 'employee.lastName',
    value: '',
    filter: <Input variant="outlined" label="Nume" type="text" />,
    type: 'text',
    label: 'Nume'
  },
  {
    name: 'employee.locationCode',
    value: '',
    filter: <Input variant="outlined" label="Cod locație" type="text" />,
    type: 'text',
    label: 'Cod locație'
  },
  {
    name: 'employee.locationName',
    value: '',
    filter: <Input variant="outlined" label="Locație" type="text" />,
    type: 'text',
    label: 'Locație'
  },
  {
    name: 'employee.locationType',
    value: '',
    filter: <Input variant="outlined" label="Tip locație" type="text" />,
    type: 'text',
    label: 'Tip locație'
  },
  {
    name: 'employee.userId',
    value: '',
    filter: <Input variant="outlined" label="User ID" type="text" />,
    type: 'text',
    label: 'User ID'
  },
  {
    name: 'employee.userName',
    value: '',
    filter: <Input variant="outlined" label="Username" type="text" />,
    type: 'text',
    label: 'Username'
  }
]
